export default "__VITE_ASSET__fef6d4ed__"